import React from 'react';
import App2, { BandeauMiseAJour } from './AVELISpro';

function App() {
  return (
    <>
      <App2 />
      {/* Hors de App2 : visible sur tous les écrans (pro, espace client, tunnel). */}
      <BandeauMiseAJour />
    </>
  );
}

export default App;
